import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {DatePickerComponent} from '@syncfusion/ej2-vue-calendars';
import {computed} from "vue";

interface Props {
  placeholder?: string,
  modelValue?: Date,
  format?: string
  name?: string
  min?: Date
  max?: Date
  width?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SogDatePicker',
  props: {
    placeholder: { default: undefined },
    modelValue: { default: undefined },
    format: { default: "dd.MM.yyyy" },
    name: { default: undefined },
    min: { default: undefined },
    max: { default: undefined },
    width: { default: "160px" }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const emit = __emit
//const input = ref<InstanceType<typeof DatePickerComponent> | null>(null)

const _style = computed<string>(() => props.width ? "width: " + props.width : "")


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(_style.value)
  }, [
    _createVNode(_unref(DatePickerComponent), {
      format: __props.format,
      placeholder: __props.placeholder,
      "float-label-type": "Always",
      value: __props.modelValue,
      min: __props.min,
      max: __props.max,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.value)))
    }, null, 8, ["format", "placeholder", "value", "min", "max"])
  ], 4))
}
}

})